'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$resource',
                function($resource) {
                    return $resource('api/reports/projects/chronology', null, {
                        get: {
                            url: 'api/reports/projects/chronology',
                            method: 'GET',
                            responseType: 'arraybuffer',
                            transformResponse: (data, headers) => {
                                return {
                                    data: data,
                                    contentType: headers('Content-Type'),
                                    contentDisposition: headers('Content-Disposition'),
                                };
                            },
                        },
                    });
                }];
